import { useEffect, useContext, useRef, useState } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'

// Context
import { NavigationContext } from '../../context/NavigationContext'
import { AppContext } from '../../context/AppContext'

// Internal components
import Button from '../Button/Button'

// Utils
import { readCookie, createCookie } from '../../utils/store/cookies'
import { UserContext } from '../../context/UserContext'

const CookieMessage = () => {
  // Context
  const navigationContext = useContext(NavigationContext)
  const appContext = useContext(AppContext)
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const refCookieMessage = useRef()
  const [loading, setLoading] = useState(true)

  // reads out cookie to see if consent has already been set and sets context variable accordingly.
  // loading state added ('buys time' in order for the cookie message to render accordingly)
  useEffect(() => {
    setLoading(false)
    navigationContext.setCookiesConsent(readCookie('cookies_consent'))
  }, [])

  // click handler to set consent.
  const setConsent = (consent) => {
    navigationContext.setCookiesConsent(consent)
    refCookieMessage.current.classList.add('is-hidden')
    createCookie('cookies_consent', consent, 30)
  }

  // shows cookies message when those are not accepted or declined yet.
  return (
    <>
      {loading || appContext?.isLatestiOSApp || navigationContext?.cookiesConsent?.length > 0 ? (
        <></>
      ) : (
        <div className="CookieMessage">
          <div className="CookieMessage-wrapper" ref={refCookieMessage}>
            <div className="CookieMessage-container">
              <p className="CookieMessage-text">
                {t('COOKIE_MESSAGE__TEXT')}{' '}
                <Link href="/infopage/cookies" passHref>
                  <a className="CookieMessage-statementLink">{t('COOKIE_MESSAGE__LINK_PRIVACY')}</a>
                </Link>
                .
              </p>
              <div className="CookieMessage-buttonWrapper">
                <Button
                  label={t('COOKIE_MESSAGE__BTN_CONSENT')}
                  modifiers={['Button--cookieMessage']}
                  onClick={() => setConsent(['all-vendors'])}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CookieMessage
